export default __webpack_public_path__ + "static/media/fad-metronome.7a4b9ff4.svg";